import { Box, Button, Stack, Typography } from "@mui/material";
import { pick } from "lodash";
import { MapLocationCard } from "src/_modules/common";
import { WarehouseAutocompleteCard } from "src/_modules/common/ServerAutocomplete";
import ContactDetails from "src/_modules/common/Details/ContactDetailsCard";
import OrderBoxesCard from "./OrderBoxesCard";
import OrderDetailsCard from "./OrderDetailsCard";
import OrderItemsCard from "./OrderItemsCard";
import AddressCard from "./AddressCard";
import { useTranslation } from "react-i18next";
import WarehouseManagementDialog from "src/modules/Warehouse/components/WarehouseManagementDialog";
import { useMemo, useState } from "react";
import { ENAAB_ID_MAPIT_SHIP, ROLES } from "src/constants";
import { Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Sender3nabDialog from "./Sender3nabDialog";

export default function MapitShipOrderForm({
  tempOrder,
  handleOrderChange,
  validationErrors,
  coordinates,
  orderReferenceNumber,
  warehouseIssues,
  hideCards = {
    orderDetailsCard: false,
    orderBoxesCard: false,
    orderItemsCard: false,
    warehouseCard: false,
    contactDetails: false,
    addressCard: false,
    mapLocationCard: false,
    landmark: false,
    Sender3nab: false
  },
}) {
  console.log(tempOrder);
  console.log("tempOrder.orderItems", tempOrder.orderItems);
  const merchant = warehouseIssues?.find((issue) => issue?.merchant?.id)
    ?.merchant?.id;
  const { profile } = useSelector((state) => state.entities.profile);
  const { t } = useTranslation();

  const isAdmin = profile?.role === ROLES.admin;
  const showHeader =
    !!orderReferenceNumber ||
    !!tempOrder?.user?.name ||
    !!tempOrder?.user?.phone;

  const [openWarehouse, setOpenWarehouse] = useState(false);

  const closeDialogHandler = () => {
    setOpenWarehouse(false);
  };
  const openDialogHandler = () => {
    setOpenWarehouse(true);
  };

  const isWarehouseNull = warehouseIssues?.some(
    (issue) => issue?.hasWarehouse === false,
  );

  const isWarehouseCityInvalid =
    !isWarehouseNull &&
    warehouseIssues?.some((issue) => issue?.warehouse?.hasValidCity === false);

  const isWarehousePhoneInvalid =
    !isWarehouseNull &&
    warehouseIssues?.some((issue) => issue?.hasValidPhone === false);

  const warehouseId = tempOrder?.warehouse;
  const isEditingWarehouse = !!warehouseId;
  const showWarehouseCard =
    !tempOrder?.id ||
    isWarehouseNull ||
    isWarehouseCityInvalid ||
    isWarehousePhoneInvalid;

  const warehouseErrorMessage = isWarehouseNull
    ? t("The Warehouse Does Not Exist. Please Specify Another Warehouse.")
    : isWarehouseCityInvalid && isWarehousePhoneInvalid
      ? t("The selected city and phone are invalid")
      : isWarehouseCityInvalid
        ? t(
            "The selected city is invalid, please choose another city or chose another warehouse.",
          )
        : isWarehousePhoneInvalid
          ? t(
              "The warehouse phone number is invalid. Please enter a valid phone number for the warehouse.",
            )
          : null;
const enabId = ENAAB_ID_MAPIT_SHIP.includes( profile?.merchant?.id)
  return (
    <Stack spacing={2}>
      {openWarehouse && (
        <WarehouseManagementDialog
          openWarehouse={openWarehouse}
          isEditing={isEditingWarehouse}
          onClose={closeDialogHandler}
          warehouseId={warehouseId}
        />
      )}
      {showHeader && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          {!!orderReferenceNumber && (
            <Stack>
              <Typography variant="h6" color="text.lighter" fontWeight="bold">
                {t("Order reference number")}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {orderReferenceNumber}
              </Typography>
            </Stack>
          )}
          {!!tempOrder?.user?.name && (
            <Stack>
              <Typography variant="h6" color="text.lighter" fontWeight="bold">
                {t("Customer Name")}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {tempOrder?.user?.name}
              </Typography>
            </Stack>
          )}
          {!!tempOrder?.user?.phone && (
            <Stack>
              <Typography variant="h6" color="text.lighter" fontWeight="bold">
                {t("Customer Phone")}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                <bdi>{tempOrder?.user?.phone}</bdi>
              </Typography>
            </Stack>
          )}
        </Box>
      )}
      {!hideCards.orderDetailsCard && (
        <OrderDetailsCard
          order={pick(tempOrder, ["amountPayable"])}
          onChange={handleOrderChange}
          errors={pick(validationErrors, ["amountPayable"])}
        />
      )}
      {!hideCards.orderBoxesCard && (
        <OrderBoxesCard
          name="boxes"
          boxesData={pick(tempOrder, ["boxes", "weight", "packagesCount"])}
          onChange={handleOrderChange}
          errors={validationErrors?.boxes}
        />
      )}
      {!hideCards.orderItemsCard && (
        <OrderItemsCard
          name="orderItems"
          orderItems={tempOrder?.orderItems ?? []}
          onChange={handleOrderChange}
          errors={validationErrors?.orderItems}
          orderReferenceNumber={orderReferenceNumber}
        />
      )}
      {!hideCards.warehouseCard && showWarehouseCard && (
        <>
          <WarehouseAutocompleteCard
            handleChange={(_, newValue) =>
              handleOrderChange({
                target: { name: "warehouse", value: newValue?.id },
              })
            }
            cardTitle={t("Warehouse")}
            value={tempOrder?.warehouse}
            label={t("Warehouses")}
            source={isAdmin ? "admin" : "merchant"}
            role={isAdmin ? "BASIC" : undefined}
            merchant={isAdmin ? merchant : undefined}
            skip={!isAdmin && profile?.merchant?.role !== ROLES.merchant}
            error={validationErrors?.warehouse}
            addNewRecord={true}
            addRecordLabel="Add New Warehouse"
            openDialog={() => setOpenWarehouse(true)}
            required
          />

          {warehouseErrorMessage && (
            <Typography variant="subtitle1" color="error.main" display="block">
              {warehouseErrorMessage}
              <Button
                variant="text"
                color="primary"
                size="small"
                startIcon={<Edit />}
                onClick={(e) => {
                  e.preventDefault();
                  if (profile?.role !== ROLES.admin) {
                    openDialogHandler();
                  }
                }}
              >
                {t("Edit")}
              </Button>
            </Typography>
          )}
        </>
      )}
      {!hideCards.contactDetails &&
        !hideCards.addressCard &&
        !hideCards.mapLocationCard && (
          <Typography variant="h4">{t("User's Info")}</Typography>
        )}
      {/* Contact and address */}
      {!hideCards.contactDetails && (
        <ContactDetails
          contact={tempOrder?.user}
          validationErrors={validationErrors?.user}
          handleChange={({ target: { name, value } }) => {
            handleOrderChange({ target: { name: `user.${name}`, value } });
          }}
        />
      )}
      {!hideCards.Sender3nab && enabId && (
        <Sender3nabDialog
          contact={tempOrder?.sender}
          validationErrors={validationErrors?.sender}
          handleChange={({ target: { name, value } }) => {
            handleOrderChange({ target: { name: `sender.${name}`, value } });
          }}
        />
      )}

      {!hideCards.addressCard && (
        <AddressCard
          cardTitle={t("Delivery Address Info")}
          address={tempOrder?.user?.address}
          handleChange={({ target: { name, value } }) => {
            name = ["address", "location.coordinates"].includes(name)
              ? `user.${name}`
              : `user.address.${name}`;
            handleOrderChange({ target: { name: name, value: value } });
          }}
          nationalAddressRequired={true}
          validationErrors={validationErrors?.user?.address}
          hideLandmark={hideCards?.landmark}
        />
      )}
      {!hideCards.mapLocationCard && (
        <MapLocationCard
          handleChange={({ target: { name, value } }) =>
            handleOrderChange({
              target: { name: `user.location.${name}`, value },
            })
          }
          coordinates={coordinates}
          error={validationErrors?.user?.location?.coordinates}
        />
      )}
    </Stack>
  );
}
